import React, { Component, PropTypes } from 'react';
import CompleteLevelButton from 'components/completeLevelButton';
import HackedImage from './bkg_hack.jpg';
import './hacked.scss';

export default class Hacked extends Component {

  static propTypes = {
    cliffHanger: PropTypes.bool
  };

  static contextTypes = {
    session: PropTypes.object.isRequired,
    isHacked: PropTypes.bool,
    presenter: PropTypes.bool,
    setHackedAnswer: PropTypes.func.isRequired,
    hideHUD: PropTypes.func.isRequired,
    i18n: PropTypes.func.isRequired
  };

  constructor (props) {
    super(props);
    this.state = {
      hacked: true,
      countdown: 5
    };
  }

  componentDidMount () {
    this.interval = setInterval(::this.countdown, 1000);
  }

  componentWillUnmount () {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  setHackedAnswer (answer) {
    const { session, setHackedAnswer, hideHUD } = this.context;
    const { currentLevel: level } = session;
    setHackedAnswer({
      level,
      answer
    });
    hideHUD();
  }

  clickHandler (evt) {
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  startHack () {
    this.setState({
      hacked: true
    });
  }

  countdown () {
    const { countdown } = this.state;
    if (countdown === 1) {
      this.startHack();
      clearInterval(this.interval);
      this.interval = null;
      return;
    }
    this.setState({
      countdown: countdown - 1
    });
  }

  changeHandler (evt) {
    this.setHackedAnswer(evt.target.value);
    if (evt) {
      evt.preventDefault();
      evt.stopPropagation();
      evt.nativeEvent.stopPropagation();
    }
  }

  keyDown (evt) {
    const { presenter } = this.context;
    if (evt) {
      if (presenter) {
        // Stop arrow key navigation on teacher remote
        if (evt.keyCode === 37 || evt.keyCode === 39) {  // left, right
          evt.stopPropagation();
          evt.nativeEvent.stopPropagation();
        }
      } else {
        // Don't use arrows for input fields in presentation mode
        if (evt.keyCode === 37 || evt.keyCode === 39) {  // left, right
          evt.preventDefault();
        }
      }
    }
  }

  render () {
    const { cliffHanger } = this.props;
    const { countdown, hacked } = this.state;
    const { session, presenter, i18n: _ } = this.context;
    const hackedAnswer = session[`zh-hacked-answer-${session.currentLevel}`];
    /*
    const {
      session: {
        isHacked
      }
    } = this.context;
    */

    return (
      <div>
        { hacked && !presenter &&
        <div className="hacked" style={{backgroundImage: 'url(' + HackedImage + ')'}}>
          <div className="hacked-form">
            { !cliffHanger ? <input
              type="text"
              onClick={::this.clickHandler}
              onChange={::this.changeHandler}
              onKeyDown={::this.keyDown}
              placeholder={_("(enter code here)")}
              value={hackedAnswer}/> : null }
            { cliffHanger ? <CompleteLevelButton/> : null }
          </div>
        </div>
        }
        { hacked && presenter &&
        <div className="hacked-remote">
          { !cliffHanger ? <input
              type="text"
              onClick={::this.clickHandler}
              onChange={::this.changeHandler}
              onKeyDown={::this.keyDown}
              placeholder={_("(enter code here)")}
              value={hackedAnswer}/> : null }
          { cliffHanger ? <CompleteLevelButton/> : null }
        </div>
        }
        { !hacked &&
        <div>
          <h1>{_('Unhacked Screen')}</h1>
          {_`This will be hacked in ${countdown} seconds.`}
        </div>
        }
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/session/presentation/components/hacked.js